/* eslint-disable @typescript-eslint/no-empty-function */
import { CloseIcon } from 'assets/icons/CloseIcon'
import { PieChart } from 'components/Chart/PieChart'
import { LineItem } from 'components/Dashboard/LineItem'
import { WidgetHeader, WidgetTitle } from 'pages/HrDashboard/Widgets/widgetParts.styled'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { RootState } from 'store'
import { DashboardCard, DCContent, P } from 'styling/GlobalStyles'
import { tokens } from 'styling/tokens'
import { IWidget } from 'types/dashboard.interface'
import { groputDashboardItems } from 'utils/helpers'
import { WidgetEditOverlay } from '../Dashboard.styled'

export const WorkersWidget = ({
  modalOpen,
  removeWidget,
  onDragStart,
  onDragOver,
  onDragDrop,
}: IWidget) => {
  const { shifts } = useSelector((state: RootState) => state.dashboard)
  const { darkMode } = useSelector((state: RootState) => state.globals)
  const shiftsData = groputDashboardItems(shifts?.shifts)

  // Theme-aware colors
  const getColors = () => {
    if (!darkMode) {
      return [
        { start: tokens.status.danger.fg, end: tokens.status.danger.fg }, // red
        { start: tokens.status.success.fg, end: tokens.status.success.fg }, // green
        { start: tokens.status.warning.fg, end: tokens.status.warning.fg }, // yellow
        { start: tokens.status.info.fg, end: tokens.status.info.fg }, // blue
        { start: tokens.status.danger.fg, end: tokens.status.danger.fg }, // purple
        { start: tokens.accent.base, end: tokens.accent.base }, // orange
        { start: tokens.status.success.fg, end: tokens.status.success.fg }, // teal
      ]
    } else {
      return [
        { start: tokens.status.danger.fg, end: tokens.status.danger.fg }, // red
        { start: tokens.status.success.fg, end: tokens.status.success.fg }, // green
        { start: tokens.status.warning.fg, end: tokens.status.warning.fg }, // yellow
        { start: tokens.status.info.fg, end: tokens.status.info.fg }, // blue
        { start: tokens.status.danger.fg, end: tokens.status.danger.fg }, // purple
        { start: tokens.accent.base, end: tokens.accent.base }, // orange
        { start: tokens.status.success.fg, end: tokens.status.success.fg }, // teal
      ]
    }
  }

  const colors = getColors()

  const navigate = useNavigate()
  return (
    <DashboardCard
      draggable={modalOpen}
      onDragStartCapture={() => {
        onDragStart('workers', 1)
      }}
      onDrop={onDragDrop}
      onDragEnd={(e) => {
        e.preventDefault()
      }}
      onDragOver={(e) => {
        e.preventDefault()
        onDragOver('workers')
      }}
      width='1fr'
      onClick={() => !modalOpen && navigate('/dashboard/employees')}
      style={{ gridArea: 'workers', cursor: modalOpen ? 'grab' : 'pointer' }}
    >
      {modalOpen && (
        <WidgetEditOverlay
          onClick={(e) => {
            removeWidget('workers')
            e.stopPropagation()
          }}
        >
          <P>Remove Widget</P>
          <CloseIcon />
        </WidgetEditOverlay>
      )}
      <WidgetHeader>
        <WidgetTitle>Employees</WidgetTitle>
      </WidgetHeader>
      <DCContent>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <PieChart
            data={shiftsData.map((item, index) => ({
              name: item.name,
              value: Number(item.value),
              color: colors[index],
            }))}
            size={180}
            showLabels={false}
            showValues={false}
          />
        </div>
        <LineItem
          borderTop
          title='Low Rated Workers'
          count={shifts?.lowRatedCount}
          noBottom
          numberOnly
        />
      </DCContent>
    </DashboardCard>
  )
}
